import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 0h24v24H0z\"></path><g transform=\"matrix(1 0 0 -1 2 22)\"><circle cx=\"10\" cy=\"10\" r=\"9.5\" stroke=\"#007CC2\"></circle><path fill=\"#007CC2\" d=\"M9 15a1 1 0 1 1 2 0 1 1 0 0 1-2 0M10 12c-.552 0-1-.453-1-.997V4.997C9 4.447 9.444 4 10 4c.552 0 1 .453 1 .997v6.006c0 .55-.444.997-1 .997\"></path></g></g>", 1)
  ]))]))
}
export default { render: render }